exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.MainOrderOptions__newLabel___CrgT9C0f {\n  display: block;\n  width: 76px;\n  height: 39px;\n  background-color: #fff;\n  border-radius: 19.4px;\n  margin-bottom: 6px;\n  font-size: 22px;\n  line-height: 43px;\n  color: #38AA3F;\n  text-transform: uppercase;\n}\n", ""]);
// Exports
exports.locals = {
	"newLabel": "MainOrderOptions__newLabel___CrgT9C0f"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/kiosk/components/MainOrderOptions.vue?vue&type=style&index=1&lang=scss&module=true&
// module id = YjQS
// module chunks = 3